import React from 'react';
import { Divider } from 'semantic-ui-react';
import { WorksheetPageIndex } from 'services/worksheet/types';
import FertilizerPrintWorksheetHeader from '../FertilizerPrintWorksheetHeader';
import FertilizerPrintWorksheetProducts from '../FertilizerPrintWorksheetProducts';
import FertilizerPrintWorksheetCompletionDetails from '../FertilizerPrintWorksheetCompletionDetails';
import FertilizerPrintWorksheetSignOff from '../FertilizerPrintWorksheetSignOff';
import FertilizerPrintWorksheetBlocks from '../FertilizerPrintWorksheetBlocks';

interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetPage(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    return (
        <div className="print-worksheet-page">
            <FertilizerPrintWorksheetHeader pageIndex={pageIndex} />
            <Divider />
            <FertilizerPrintWorksheetBlocks pageIndex={pageIndex} />
            <FertilizerPrintWorksheetProducts pageIndex={pageIndex} />
            <FertilizerPrintWorksheetCompletionDetails pageIndex={pageIndex} />
            <FertilizerPrintWorksheetSignOff />
        </div>
    );
}
